app.factory("ContentFactory", [
  "$http",
  "config",
  "decrypt",
  "$q",
  "$localStorage",
  function ($http, config, decrypt, $q, $localStorage) {
    return {
      getContentType(contentId) {
        let q = $q.defer();
        $http({
          method: "GET",
          url: `${config.fstreamAPI}getContentType/${contentId}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then(
          function success(response) {
            q.resolve(response.data.data.type);
          },
          function myError() {
            q.reject(null);
          }
        );
        return q.promise;
      },
      getContent(contentId, contentType) {
        let q = $q.defer();
        $http({
          method: "GET",
          url: `${publicApiUrl}getShopContentByID/${$localStorage.siteID}/${contentType}/${contentId}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then(
          function success(response) {
            q.resolve(response.data.data[0]);
          },
          function error() {
            q.reject(null);
          }
        );
        return q.promise;
      },
      getCustomerTickets(customerId) {
        let q = $q.defer();
        $http({
          method: "POST",
          url: `${config.fstreamAPI}getCustomerTickets`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: {
            siteID: $localStorage.siteID,
            customerID: customerId,
          },
        }).then(
          function success(response) {
            q.resolve(response.data.data.tickets);
          },
          function error(response) {
            q.reject(null);
          }
        );
        return q.promise;
      },
      checkTicketsForContentId(tickets, contentId) {
        let alreadyOwned = false;
        for (let i = 0; i < tickets.length; i++) {
          if (tickets[i].contentID === contentId) {
            alreadyOwned = true;
            break;
          }
        }
        return alreadyOwned;
      },
    };
  },
]);
